var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useContext, useMemo } from 'react';
import { useList } from "../../controller/index.js";
import { ChoicesContext } from "./ChoicesContext.js";
export var useChoicesContext = function (options) {
    var _a, _b, _c;
    if (options === void 0) { options = {}; }
    var context = useContext(ChoicesContext);
    var choices = options.choices && isArrayOfStrings(options.choices)
        ? convertOptionsToChoices(options.choices)
        : options.choices;
    // @ts-ignore cannot satisfy the type of useList because of ability to pass partial options
    var _d = useList({
        data: choices,
        isLoading: (_a = options.isLoading) !== null && _a !== void 0 ? _a : false,
        isPending: (_b = options.isPending) !== null && _b !== void 0 ? _b : false,
        isFetching: (_c = options.isFetching) !== null && _c !== void 0 ? _c : false,
        error: options.error,
        // When not in a ChoicesContext, paginating does not make sense (e.g. AutocompleteInput).
        perPage: Infinity,
    }), data = _d.data, list = __rest(_d, ["data"]);
    var result = useMemo(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
        // Props take precedence over context.
        if (options.choices || !context) {
            return {
                allChoices: data,
                availableChoices: (_a = options.availableChoices) !== null && _a !== void 0 ? _a : data,
                selectedChoices: (_b = options.selectedChoices) !== null && _b !== void 0 ? _b : data,
                displayedFilters: (_c = options.selectedChoices) !== null && _c !== void 0 ? _c : list.displayedFilters,
                error: options.error,
                filter: (_d = options.filter) !== null && _d !== void 0 ? _d : list.filter,
                filterValues: (_e = options.filterValues) !== null && _e !== void 0 ? _e : list.filterValues,
                hasNextPage: (_f = options.hasNextPage) !== null && _f !== void 0 ? _f : list.hasNextPage,
                hasPreviousPage: (_g = options.hasPreviousPage) !== null && _g !== void 0 ? _g : list.hasPreviousPage,
                hideFilter: (_h = options.hideFilter) !== null && _h !== void 0 ? _h : list.hideFilter,
                isFetching: (_j = list.isFetching) !== null && _j !== void 0 ? _j : false, // we must take the one for useList, otherwise the loading state isn't synchronized with the data
                isLoading: (_k = list.isLoading) !== null && _k !== void 0 ? _k : false, // same
                isPaused: (_l = list.isPaused) !== null && _l !== void 0 ? _l : false, // same
                isPending: (_m = list.isPending) !== null && _m !== void 0 ? _m : false, // same
                isPlaceholderData: (_o = list.isPlaceholderData) !== null && _o !== void 0 ? _o : false, // same
                page: (_p = options.page) !== null && _p !== void 0 ? _p : list.page,
                perPage: (_q = options.perPage) !== null && _q !== void 0 ? _q : list.perPage,
                refetch: (_r = options.refetch) !== null && _r !== void 0 ? _r : list.refetch,
                resource: (_s = options.resource) !== null && _s !== void 0 ? _s : list.resource,
                setFilters: (_t = options.setFilters) !== null && _t !== void 0 ? _t : list.setFilters,
                setPage: (_u = options.setPage) !== null && _u !== void 0 ? _u : list.setPage,
                setPerPage: (_v = options.setPerPage) !== null && _v !== void 0 ? _v : list.setPerPage,
                setSort: (_w = options.setSort) !== null && _w !== void 0 ? _w : list.setSort,
                showFilter: (_x = options.showFilter) !== null && _x !== void 0 ? _x : list.showFilter,
                sort: (_y = options.sort) !== null && _y !== void 0 ? _y : list.sort,
                source: options.source,
                total: (_z = options.total) !== null && _z !== void 0 ? _z : list.total,
                isFromReference: false,
            };
        }
        return context;
    }, [context, data, list, options]);
    return result;
};
var isArrayOfStrings = function (choices) {
    return Array.isArray(choices) &&
        choices.every(function (choice) { return typeof choice === 'string'; });
};
var convertOptionsToChoices = function (options) {
    return options.map(function (choice) { return ({
        id: choice,
        name: choice,
    }); });
};
//# sourceMappingURL=useChoicesContext.js.map